import styled from "styled-components";

export const Container = styled.div`
  z-index: 99999;
  padding: 30px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  opacity: 0.9;
  font-size: 24px;
  text-align: center;
`;
